import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-available-media-control',
  templateUrl: './available-media.component.html',
  styleUrls: ['./available-media.component.scss']
})
export class AvailableMediaControlComponent {

  constructor(
    public dialogRef: MatDialogRef<AvailableMediaControlComponent>
  ) { }

  dialogAction(isContinue: boolean) {
		return this.dialogRef.close(isContinue);
  }
}
